<template>
    <ul class="nav d-flex flex-lg-row flex-column justify-content-between w-100">
        <li
            v-for="(item, index) in useMenuStore().topMain"
            :key="index"
            class="nav-item top-menu"
            :class="{
        dropdown: item.has_children,
        hoverable: hoverState[index],
        'dropdown-100': item.is_extended,
        'dropdown-auto': !item.is_extended && item.has_children
      }"
            @mouseover="hoverState[index] = true"
            @mouseleave="hoverState[index] = false"
        >
            <NuxtLink
                v-if="item.link"
                :to="item.link"
                class="nav-link top-menu-link text-uppercase"
                :class="[item.class, { 'dropdown-toggle': item.has_children }]"
                :rel="item.no_follow ? 'no_follow' : 'noopener noreferrer'"
                :id="item.has_children ? `dropdown${index}` : null"
                :data-bs-toggle="useMobileDetector() && item.has_children ? 'dropdown' : null"
                :aria-expanded="useMobileDetector() && item.has_children ? 'false' : null"
                @click="menuItemClicked(item, index)"
            >
                {{ item.title }}
            </NuxtLink>
            <span
                v-else
                :id="`dropdown${index}`"
                class="nav-link disabled"
                role="button"
                tabindex="0"
                @click.prevent="menuItemClicked(item, index)"
            >
        {{ item.title }}
      </span>

            <div
                v-if="item.has_children"
                class="dropdown-menu"
                :aria-labelledby="item.has_children ? `dropdown${index}` : null"
            >
                <ExtendedMenuItem
                    v-if="item.is_extended"
                    :content="item"
                    @toggle-dropdown="closeDropdown(index)"
                />
                <template v-else>
                    <NuxtLink
                        v-for="dropdownItem in item.children"
                        :key="dropdownItem.title"
                        class="dropdown-item"
                        :to="dropdownItem.link"
                    >
                        {{ dropdownItem.title }}
                    </NuxtLink>
                </template>
            </div>
        </li>
    </ul>
</template>

<script setup>
const ExtendedMenuItem = defineAsyncComponent(() => import('~/components/Menu/ExtendedMenuItem.vue'))
import { useMenuStore } from '~/stores/MenuStore';

const menuStore = useMenuStore();

const menu = menuStore.topMain;
const hoverState = ref(menu.map(() => false));

const closeDropdown = (index) => {
    hoverState.value[index] = false;
};

const menuItemClicked = (item, index) => {
    closeDropdown(index);
    if (item?.has_children || !useMobileDetector()) return;
    const toggleButton = document.getElementById('navbarToggleButton');
    if (toggleButton) toggleButton.click();
};
</script>
